import { Component, inject, Input, ChangeDetectionStrategy } from '@angular/core';
import { ModalController, IonicModule } from '@ionic/angular';
import { BaseJob } from 'src/app/types';
import { AnyJobBase } from 'src/app/types/any-job-base';
import { RouteEventCardComponent } from '../../components/route-event-card/route-event-card.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  templateUrl: './waypoint-details.dialog.html',
  styleUrls: ['./waypoint-details.dialog.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IonicModule, RouteEventCardComponent, TranslatePipe],
})
export class WaypointDetailsDialog {
  private readonly gtm = (<any>window).dataLayer || [];

  private readonly modalCtrl = inject(ModalController);

  public data: AnyJobBase;
  public job: BaseJob;
  public duration: string;

  @Input() set routeEvent(routeEvent: AnyJobBase) {
    this.job = routeEvent.value;
    this.data = routeEvent;
    this.duration =
      this.data.scheduledStart && this.data.scheduledEnd
        ? this.data.scheduledEnd
            .diff(this.data.scheduledStart)
            .rescale()
            .toHuman({ listStyle: 'long' })
        : null;
  }

  constructor() {
    this.gtm.push({ event: 'custom_event', custom_event_name: 'view_ job_details' });
  }

  public onCancel(): void {
    this.modalCtrl.dismiss();
  }
}
